import {createGrid} from "../../helpers/grids/grids";
import {createCellRenderer} from "../../helpers/grids/helpers";
import createElement from "../../helpers/createElement";

function initCallsIndex() {
	// Init grid
	createGrid('.calls-grid', {
			columnDefs: [
				{
					field: 'source_phone.name',
					headerName: 'To',
				},
				{
					field: 'from',
					headerName: 'From',
				},
				{
					field: 'recording_url',
					headerName: 'Recording',
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						const recordingUrl = params.data.recording_url;

						if (!recordingUrl) {
							return createElement('<span class="text-muted">Not Available</span>');
						} else {
							return createElement(`<a href="${recordingUrl}" target="_blank">Download</a>`)
						}
					})
				},
				{
					field: 'transcribe_url',
					headerName: 'Transcription',
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						const transcriptionUrl = params.data.transcription_url;

						if (!transcriptionUrl) {
							return createElement('<span class="text-muted">Not Available</span>');
						} else {
							return createElement(`<a href="${transcriptionUrl}" target="_blank">View</a>`)
						}
					})
				},
				{
					field: 'created_at',
					headerName: 'At',
					sortable: 'true',
					sort: 'desc',
				},
			],
			paginationPageSize: 20,
			_rowName: 'Calls',
			rowClass: 'cursor-pointer',
		},
		window['routes/admin.calls.grid'],
	);
}

export {
	initCallsIndex
}
